import * as React from 'react'
import { SVGProps } from 'react'
import PropTypes from 'prop-types'
interface SVGRProps {
    title?: string;
    titleId?: string;
}
function SvgHeart({
    title,
    titleId,
    ...props
}: SVGProps<SVGSVGElement> & SVGRProps) {
    return (
        <svg
            viewBox="0 0 140 128"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path
                d="M69.91 127.12c-1 0-2-.31-2.85-.93C64.35 124.22.64 77.47.64 40.71.64 16.89 17.13 2.47 33.41.54c12.13-1.46 27.58 3.84 36.5 21.79C78.83 4.37 94.3-.95 106.41.54c16.28 1.93 32.77 16.35 32.77 40.17 0 36.76-63.71 83.51-66.42 85.48-.85.62-1.85.93-2.85.93ZM37.35 9.99c-.95 0-1.88.06-2.79.17-12.04 1.43-24.23 12.38-24.23 30.56 0 25.09 40.61 61.13 59.59 75.53 18.97-14.4 59.59-50.44 59.59-75.53 0-18.17-12.19-29.13-24.23-30.56-11.3-1.34-25.25 5.24-30.65 27.69a4.844 4.844 0 0 1-9.42 0C60.25 17.22 48.05 9.99 37.35 9.99Z"
                fill="currentColor"
            />
        </svg>
    )
}
SvgHeart.propTypes = {
    title: PropTypes.string,
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    stroke: PropTypes.string,
    color: PropTypes.string,
}
export default SvgHeart
